import { render, staticRenderFns } from "./Tickets.html?vue&type=template&id=3055eb64&scoped=true&"
import script from "./Tickets.js?vue&type=script&lang=js&"
export * from "./Tickets.js?vue&type=script&lang=js&"
import style0 from "./Tickets.scss?vue&type=style&index=0&id=3055eb64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055eb64",
  null
  
)

export default component.exports